export const CONFIRM_STATUS = {
  NOT_AUDIT: 1,
  AUDITED: 2,
  CONFIRMED: 3,
  RESPONSE_WRONG: 4
}

export const CASHIER_CONFIRM_TYPE = {
  CONFIRM: 1,
  REPORT_WRONG: 2
}
